import ViewerDashboard from "../pages/Viewer/Dashboard/ViewerDashboard";

import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import Profile from "../pages/Viewer/Profile/Profile";
import ReferralMaterials from "../pages/Viewer/ReferralMaterials/ReferralMaterials";
import RegistrationRequest from "../pages/Viewer/RegistrationRequest/RegistrationRequest";

var ViewerRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <ViewerDashboard />,
    layout: "coordinator",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "referral-materials",
    name: "Referrral Materials",
    element: <ReferralMaterials />,
    layout: "coordinator",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "requests",
    name: "Requests",
    element: <RegistrationRequest />,
    layout: "coordinator",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "coordinator",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ViewerRoutes;
